import { CalendarDays, CheckCircle2, ChevronRight, Clock3, MapPin, Swords } from 'lucide-react'
import { Link } from 'react-router-dom'
import { countryFlag, formatEventDate, timeUntil } from '../lib/format'
import type { EventDTO } from '../types/domain'
import { StatusPill } from './ui'

export function EventHero({ event, completed, total, isGuest = false }: { event: EventDTO; completed: number; total: number; isGuest?: boolean }) {
  const percent = total ? Math.round((completed / total) * 100) : 0
  return (
    <section className="event-hero">
      <div className="event-hero__glow" />
      <div className="event-hero__body">
        <div className="event-hero__topline">
          <StatusPill tone="accent">Próximo evento</StatusPill>
          <span className="event-hero__countdown"><Clock3 size={16} /> {timeUntil(event.lockAt)}</span>
        </div>
        <div className="event-hero__title">
          <span className="event-hero__league">{event.name}</span>
          <h1>{event.headline}</h1>
        </div>
        <div className="event-hero__meta">
          <span><CalendarDays size={17} /> {formatEventDate(event.startAt)}</span>
          <span><MapPin size={17} /> {event.city} {countryFlag(event.countryCode)}</span>
        </div>
        <div className="event-hero__progress-card">
          <div className="progress-summary">
            <span className="progress-summary__icon"><Swords size={22} /></span>
            <div>
              <strong>{isGuest ? 'Monte seu card' : completed === total ? 'Card completo' : 'Seus palpites'}</strong>
              <span>{isGuest ? `${total} lutas disponíveis para palpitar` : `${completed} de ${total} lutas preenchidas`}</span>
            </div>
            <strong className="progress-summary__percent">{isGuest ? 'GRÁTIS' : `${percent}%`}</strong>
          </div>
          <div className="progress-track" aria-label={isGuest ? 'Crie uma conta grátis para preencher o card' : `${percent}% do card preenchido`}>
            <span style={{ width: `${percent}%` }} />
          </div>
        </div>
        <Link to="/palpites" className="event-hero__cta">
          {completed ? <CheckCircle2 size={20} /> : <Swords size={20} />}
          {isGuest ? 'Criar conta para palpitar' : completed === total ? 'Revisar palpites' : 'Continuar card'}
          <ChevronRight size={20} />
        </Link>
      </div>
      <div className="event-hero__mark" aria-hidden="true">
        <img src="/brand/logo-512.webp" alt="" width="250" height="250" />
      </div>
    </section>
  )
}
